import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RespuestaCuadrosSalidaChvDto } from 'src/app/modelos/cuadrossalida/RespuestaCuadrosSalidaChvDto';
import { HOST } from '../../global';
import { CUADROS_SALIDA } from '../../global';
import { CUADROS_CHV } from '../../global';
import { CUADROS_FIVI, VERIFICAR_ICOCED, GUARDAR_ICOCED } from '../../global';


@Injectable({
  providedIn: 'root'
})
export class CuadrossalidaService {

  url: string= HOST;

constructor(
  private http: HttpClient
) { }

//Lista años desde Vigencias
getCuadrosSalidaChv(cuadro: any):Observable<RespuestaCuadrosSalidaChvDto>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + CUADROS_SALIDA + CUADROS_CHV + "/" + cuadro;
  return this.http.get<RespuestaCuadrosSalidaChvDto>(direccion,{'headers': header});
}

//Lista años desde Vigencias
getCuadroSalidaFivi(cuadro: any, parametro: any):Observable<any>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + CUADROS_SALIDA + CUADROS_FIVI + "/" + cuadro + "/" + parametro;
  return this.http.get<any>(direccion,{'headers': header});
}

verificarExisteIcoced():Observable<boolean>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + CUADROS_SALIDA + CUADROS_FIVI + VERIFICAR_ICOCED;
  return this.http.get<boolean>(direccion,{'headers': header});
}

guardarIcoced(parametro: any):Observable<boolean>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + CUADROS_SALIDA + CUADROS_FIVI + GUARDAR_ICOCED + parametro;
  return this.http.get<boolean>(direccion,{'headers': header});
}

}
